import {Component, Input, OnInit} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {SETTINGS} from "../../../core/config/common.settings";
import {NzModalRef} from "ng-zorro-antd/modal";
import {getSubstringAfterLastComma} from "../../../core/ult-functions/text";
import {destinationMergeChecker} from "../../../core/ult-functions/destination";
import { NzMessageService } from 'ng-zorro-antd/message';
import { OpenAiService } from '../../../core/services/open-ai.service';

@Component({
  selector: 'app-add-edit-remarks-title',
  templateUrl: './add-edit-remarks-title.component.html',
  styleUrls: ['./add-edit-remarks-title.component.scss']
})
export class AddEditRemarksTitleComponent implements OnInit {
  @Input() index?: number;
  @Input() currentTitle?: string;
  @Input() language: any;
  @Input() fieldLabelKey = "itineraries.addEditRemarksTitle.title";
  @Input() placeholderKey = "itineraries.addEditRemarksTitle.placeholders.enterTitle";
  isButtonLoading = false;
  editedTitle: string|undefined = "";

  constructor(
    private modal: NzModalRef,
    private message: NzMessageService,
    private openAiService: OpenAiService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.editedTitle = this.currentTitle;
  }

  handleCancel(): void {
    this.modal.close({message: "error"});
  }

  editRemarksTitle(): void  {
    this.isButtonLoading = true;
    this.modal.close({message: "success", title: this.editedTitle});
  }

  async translateHotelDescription(text: any): Promise<any> {
    this.isButtonLoading = true;
    const payload = ` ${text}
    Translate above english into ${this.language.name}.
    if the above text is not in english, rewrite text in ${this.language.name} and remove any english parts `;

    try {
      const answer = await this.openAiService.askChatGPT({query: payload});
      if (answer) {
        this.editedTitle = answer.choices[0].message.content;
      }
      this.isButtonLoading = false;
    } catch (error) {
      this.message.error(this.translocoService.translate('itineraries.addEditRemarksTitle.messages.translateIssue'));
      this.isButtonLoading = false;
    }
  }
}
